import { PYLPurchaseSpinOrCollectState } from 'states/pyl-purchase-spin-or-collect-state';
import { BlastworksClientEvent, ClientController } from 'client-controller';

/**
 * Social purchase or collect state to send purchase state message
 *
 * @class SocialPurchaseSpinOrCollectState
 * @typedef {SocialPurchaseSpinOrCollectState}
 * @extends {PYLPurchaseSpinOrCollectState}
 */
export class SocialPurchaseSpinOrCollectState extends PYLPurchaseSpinOrCollectState {
  /**
   * Send purchase spin message
   *
   * @public
   * @override
   */
  public onEnter(): void {
    ClientController.getInstance().raiseEvent(BlastworksClientEvent.PURCHASE_SPIN);
    super.onEnter();
  }
}
